import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from 'react-i18next';
import { env } from '@/config';
import { useSidebar } from '@/hooks/useSidebar';
import { Breadcrumbs } from '@/components/common/Breadcrumbs';
import { AccountMenu } from './AccountMenu';
import { LanguageSwitcher } from './LanguageSwitcher';
import { NotificationsMenu } from './NotificationsMenu';
import { ThemeToggle } from './ThemeToggle';
import { DRAWER_WIDTH, DRAWER_WIDTH_COLLAPSED } from './NavDrawer';

interface HeaderProps {
  onMenuClick: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  const { t } = useTranslation();
  const { collapsed } = useSidebar();
  const drawerWidth = collapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH;

  return (
    <AppBar
      position="fixed"
      color="default"
      elevation={1}
      sx={{
        width: { md: `calc(100% - ${drawerWidth}px)` },
        ml: { md: `${drawerWidth}px` },
        zIndex: (theme) => theme.zIndex.drawer + 1,
        transition: (theme) => theme.transitions.create(['width', 'margin']),
      }}
    >
      <Toolbar sx={{ gap: 1 }}>
        <IconButton
          color="inherit"
          edge="start"
          onClick={onMenuClick}
          sx={{ display: { xs: 'inline-flex', md: 'none' } }}
          aria-label={t('layout.openMenu')}
        >
          <MenuIcon />
        </IconButton>

        <Box
          component="img"
          src="/logos/logo-main.svg"
          alt={env.appName}
          sx={{ display: { xs: 'block', md: 'none' }, height: 28, width: 'auto', maxWidth: 140 }}
        />

        <Box sx={{ display: { xs: 'none', md: 'block' }, minWidth: 0, flexShrink: 1 }}>
          <Breadcrumbs />
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
          <LanguageSwitcher />
          <ThemeToggle />
          <NotificationsMenu />
          <AccountMenu />
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
